export default {
    "AF": { name: "Afgh\u00e1nist\u00e1n" },
    "AX": { name: "\u00c5landy" },
    "AL": { name: "Alb\u00e1nie" },
    "DZ": { name: "Al\u017e\u00edrsko" },
    "AS": { name: "Americk\u00e1 Samoa" },
    "VI": { name: "Americk\u00e9 Panensk\u00e9 ostrovy" },
    "AD": { name: "Andorra" },
    "AO": { name: "Angola" },
    "AI": { name: "Anguilla" },
    "AQ": { name: "Antarktida" },
    "AG": { name: "Antigua a Barbuda" },
    "AR": { name: "Argentina" },
    "AM": { name: "Arm\u00e9nie" },
    "AW": { name: "Aruba" },
    "AC": { name: "Ascension" },
    "AU": { name: "Austr\u00e1lie" },
    "AZ": { name: "\u00c1zerb\u00e1jd\u017e\u00e1n" },
    "BS": { name: "Bahamy" },
    "BH": { name: "Bahrajn" },
    "BD": { name: "Banglad\u00e9\u0161" },
    "BB": { name: "Barbados" },
    "BE": { name: "Belgie" },
    "BZ": { name: "Belize" },
    "BY": { name: "B\u011blorusko" },
    "BJ": { name: "Benin" },
    "BM": { name: "Bermudy" },
    "BT": { name: "Bh\u00fat\u00e1n" },
    "BO": { name: "Bol\u00edvie" },
    "BA": { name: "Bosna a Hercegovina" },
    "BW": { name: "Botswana" },
    "BR": { name: "Braz\u00edlie" },
    "IO": { name: "Britsk\u00e9 indickooce\u00e1nsk\u00e9 \u00fazem\u00ed" },
    "VG": { name: "Britsk\u00e9 Panensk\u00e9 ostrovy" },
    "BN": { name: "Brunej" },
    "BG": { name: "Bulharsko" },
    "BF": { name: "Burkina Faso" },
    "BI": { name: "Burundi" },
    "EA": { name: "Ceuta a Melilla" },
    "CK": { name: "Cookovy ostrovy" },
    "CW": { name: "Cura\u00e7ao" },
    "TD": { name: "\u010cad" },
    "ME": { name: "\u010cern\u00e1 Hora" },
    "CZ": { name: "\u010cesk\u00e1 republika" },
    "CN": { name: "\u010c\u00edna" },
    "DK": { name: "D\u00e1nsko" },
    "DG": { name: "Diego Garc\u00eda" },
    "DM": { name: "Dominika" },
    "DO": { name: "Dominik\u00e1nsk\u00e1 republika" },
    "DJ": { name: "D\u017eibutsko" },
    "EG": { name: "Egypt" },
    "EC": { name: "Ekv\u00e1dor" },
    "ER": { name: "Eritrea" },
    "EE": { name: "Estonsko" },
    "ET": { name: "Etiopie" },
    "FO": { name: "Faersk\u00e9 ostrovy" },
    "FK": { name: "Falklandsk\u00e9 ostrovy" },
    "FJ": { name: "Fid\u017ei" },
    "PH": { name: "Filip\u00edny" },
    "FI": { name: "Finsko" },
    "FR": { name: "Francie" },
    "GF": { name: "Francouzsk\u00e1 Guyana" },
    "TF": { name: "Francouzsk\u00e1 ji\u017en\u00ed \u00fazem\u00ed" },
    "PF": { name: "Francouzsk\u00e1 Polyn\u00e9sie" },
    "GA": { name: "Gabon" },
    "GM": { name: "Gambie" },
    "GH": { name: "Ghana" },
    "GI": { name: "Gibraltar" },
    "GD": { name: "Grenada" },
    "GL": { name: "Gr\u00f3nsko" },
    "GE": { name: "Gruzie" },
    "GP": { name: "Guadeloupe" },
    "GU": { name: "Guam" },
    "GT": { name: "Guatemala" },
    "GG": { name: "Guernsey" },
    "GN": { name: "Guinea" },
    "GW": { name: "Guinea-Bissau" },
    "GY": { name: "Guyana" },
    "HT": { name: "Haiti" },
    "HN": { name: "Honduras" },
    "HK": { name: "Hongkong \u2013 ZAO \u010c\u00edny" },
    "CL": { name: "Chile" },
    "HR": { name: "Chorvatsko" },
    "IN": { name: "Indie" },
    "ID": { name: "Indon\u00e9sie" },
    "IQ": { name: "Ir\u00e1k" },
    "IR": { name: "\u00cdr\u00e1n" },
    "IE": { name: "Irsko" },
    "IS": { name: "Island" },
    "IT": { name: "It\u00e1lie" },
    "IL": { name: "Izrael" },
    "JM": { name: "Jamajka" },
    "JP": { name: "Japonsko" },
    "YE": { name: "Jemen" },
    "JE": { name: "Jersey" },
    "ZA": { name: "Jihoafrick\u00e1 republika" },
    "GS": { name: "Ji\u017en\u00ed Georgie a Ji\u017en\u00ed Sandwichovy ostrovy" },
    "KR": { name: "Ji\u017en\u00ed Korea" },
    "SS": { name: "Ji\u017en\u00ed S\u00fad\u00e1n" },
    "JO": { name: "Jord\u00e1nsko" },
    "KY": { name: "Kajmansk\u00e9 ostrovy" },
    "KH": { name: "Kambod\u017ea" },
    "CM": { name: "Kamerun" },
    "CA": { name: "Kanada" },
    "IC": { name: "Kan\u00e1rsk\u00e9 ostrovy" },
    "CV": { name: "Kapverdy" },
    "BQ": { name: "Karibsk\u00e9 Nizozemsko" },
    "QA": { name: "Katar" },
    "KZ": { name: "Kazachst\u00e1n" },
    "KE": { name: "Ke\u0148a" },
    "KI": { name: "Kiribati" },
    "CC": { name: "Kokosov\u00e9 ostrovy" },
    "CO": { name: "Kolumbie" },
    "KM": { name: "Komory" },
    "CG": { name: "Kongo \u2013 Brazzaville" },
    "CD": { name: "Kongo \u2013 Kinshasa" },
    "XK": { name: "Kosovo" },
    "CR": { name: "Kostarika" },
    "CU": { name: "Kuba" },
    "KW": { name: "Kuvajt" },
    "CY": { name: "Kypr" },
    "KG": { name: "Kyrgyzst\u00e1n" },
    "LA": { name: "Laos" },
    "LS": { name: "Lesotho" },
    "LB": { name: "Libanon" },
    "LR": { name: "Lib\u00e9rie" },
    "LY": { name: "Libye" },
    "LI": { name: "Lichten\u0161tejnsko" },
    "LT": { name: "Litva" },
    "LV": { name: "Loty\u0161sko" },
    "LU": { name: "Lucembursko" },
    "MO": { name: "Macao \u2013 ZAO \u010c\u00edny" },
    "MG": { name: "Madagaskar" },
    "HU": { name: "Ma\u010farsko" },
    "MK": { name: "Makedonie" },
    "MY": { name: "Malajsie" },
    "MW": { name: "Malawi" },
    "MV": { name: "Maledivy" },
    "ML": { name: "Mali" },
    "MT": { name: "Malta" },
    "MA": { name: "Maroko" },
    "MH": { name: "Marshallovy ostrovy" },
    "MQ": { name: "Martinik" },
    "MU": { name: "Mauricius" },
    "MR": { name: "Maurit\u00e1nie" },
    "YT": { name: "Mayotte" },
    "UM": { name: "Men\u0161\u00ed odlehl\u00e9 ostrovy USA" },
    "MX": { name: "Mexiko" },
    "FM": { name: "Mikron\u00e9sie" },
    "MD": { name: "Moldavsko" },
    "MC": { name: "Monako" },
    "MN": { name: "Mongolsko" },
    "MS": { name: "Montserrat" },
    "MZ": { name: "Mosambik" },
    "MM": { name: "Myanmar (Barma)" },
    "NA": { name: "Namibie" },
    "NR": { name: "Nauru" },
    "DE": { name: "N\u011bmecko" },
    "NP": { name: "Nep\u00e1l" },
    "NE": { name: "Niger" },
    "NG": { name: "Nig\u00e9rie" },
    "NI": { name: "Nikaragua" },
    "NU": { name: "Niue" },
    "NL": { name: "Nizozemsko" },
    "NF": { name: "Norfolk" },
    "NO": { name: "Norsko" },
    "NC": { name: "Nov\u00e1 Kaledonie" },
    "NZ": { name: "Nov\u00fd Z\u00e9land" },
    "OM": { name: "Om\u00e1n" },
    "IM": { name: "Ostrov Man" },
    "PK": { name: "P\u00e1kist\u00e1n" },
    "PW": { name: "Palau" },
    "PS": { name: "Palestinsk\u00e1 \u00fazem\u00ed" },
    "PA": { name: "Panama" },
    "PG": { name: "Papua-Nov\u00e1 Guinea" },
    "PY": { name: "Paraguay" },
    "PE": { name: "Peru" },
    "PN": { name: "Pitcairnovy ostrovy" },
    "CI": { name: "Pob\u0159e\u017e\u00ed slonoviny" },
    "PL": { name: "Polsko" },
    "PR": { name: "Portoriko" },
    "PT": { name: "Portugalsko" },
    "AT": { name: "Rakousko" },
    "RE": { name: "R\u00e9union" },
    "GQ": { name: "Rovn\u00edkov\u00e1 Guinea" },
    "RO": { name: "Rumunsko" },
    "RU": { name: "Rusko" },
    "RW": { name: "Rwanda" },
    "GR": { name: "\u0158ecko" },
    "PM": { name: "Saint-Pierre a Miquelon" },
    "SV": { name: "Salvador" },
    "WS": { name: "Samoa" },
    "SM": { name: "San Marino" },
    "SA": { name: "Sa\u00fadsk\u00e1 Ar\u00e1bie" },
    "SN": { name: "Senegal" },
    "KP": { name: "Severn\u00ed Korea" },
    "MP": { name: "Severn\u00ed Mariany" },
    "SC": { name: "Seychely" },
    "SL": { name: "Sierra Leone" },
    "SG": { name: "Singapur" },
    "SK": { name: "Slovensko" },
    "SI": { name: "Slovinsko" },
    "SO": { name: "Som\u00e1lsko" },
    "AE": { name: "Spojen\u00e9 arabsk\u00e9 emir\u00e1ty" },
    "US": { name: "Spojen\u00e9 st\u00e1ty" },
    "RS": { name: "Srbsko" },
    "LK": { name: "Sr\u00ed Lanka" },
    "CF": { name: "St\u0159edoafrick\u00e1 republika" },
    "SD": { name: "S\u00fad\u00e1n" },
    "SR": { name: "Surinam" },
    "SH": { name: "Svat\u00e1 Helena" },
    "LC": { name: "Svat\u00e1 Lucie" },
    "BL": { name: "Svat\u00fd Bartolom\u011bj" },
    "KN": { name: "Svat\u00fd Kry\u0161tof a Nevis" },
    "MF": { name: "Svat\u00fd Martin (Francie)" },
    "SX": { name: "Svat\u00fd Martin (Nizozemsko)" },
    "ST": { name: "Svat\u00fd Tom\u00e1\u0161 a Princ\u016fv ostrov" },
    "VC": { name: "Svat\u00fd Vincenc a Grenadiny" },
    "SZ": { name: "Svazijsko" },
    "SY": { name: "S\u00fdrie" },
    "SB": { name: "\u0160alamounovy ostrovy" },
    "ES": { name: "\u0160pan\u011blsko" },
    "SJ": { name: "\u0160picberky a Jan Mayen" },
    "SE": { name: "\u0160v\u00e9dsko" },
    "CH": { name: "\u0160v\u00fdcarsko" },
    "TJ": { name: "T\u00e1d\u017eikist\u00e1n" },
    "TZ": { name: "Tanzanie" },
    "TH": { name: "Thajsko" },
    "TW": { name: "Tchaj-wan" },
    "TG": { name: "Togo" },
    "TK": { name: "Tokelau" },
    "TO": { name: "Tonga" },
    "TT": { name: "Trinidad a Tobago" },
    "TA": { name: "Tristan da Cunha" },
    "TN": { name: "Tunisko" },
    "TR": { name: "Turecko" },
    "TM": { name: "Turkmenist\u00e1n" },
    "TC": { name: "Turks a Caicos" },
    "TV": { name: "Tuvalu" },
    "UG": { name: "Uganda" },
    "UA": { name: "Ukrajina" },
    "UY": { name: "Uruguay" },
    "UZ": { name: "Uzbekist\u00e1n" },
    "CX": { name: "V\u00e1no\u010dn\u00ed ostrov" },
    "VU": { name: "Vanuatu" },
    "VA": { name: "Vatik\u00e1n" },
    "GB": { name: "Velk\u00e1 Brit\u00e1nie" },
    "VE": { name: "Venezuela" },
    "VN": { name: "Vietnam" },
    "TL": { name: "V\u00fdchodn\u00ed Timor" },
    "WF": { name: "Wallis a Futuna" },
    "ZM": { name: "Zambie" },
    "EH": { name: "Z\u00e1padn\u00ed Sahara" },
    "ZW": { name: "Zimbabwe" }
};
